import * as React from 'react';
import { useAccount } from '@azure/msal-react';
import {
	Avatar as MuiAvatar,
	Box,
	Typography,
	List,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Button
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { getInitials, logoutAccount } from '@/auth';

export const Avatar = () => {
	const profile = useAccount();
	const [open, setOpen] = React.useState(false);

	const onLogout = async () => {
		await logoutAccount();
	};

	const onAccountClick = () => {
		setOpen(open => !open);
	};

	return (
		<Box sx={{ background: '#252525' }}>
			<List
				component='nav'
				sx={{
					width: '100%',
					maxWidth: '100%'
				}}
				disablePadding
				dense>
				<ListItemButton
					sx={{
						backgroundColor: '#252525',
						'&:hover': {
							backgroundColor: 'info.main'
						},
						color: 'primary.contrastText'
					}}
					divider
					onClick={onAccountClick}>
					<ListItemIcon color='inherit'>
						<MuiAvatar
							variant='circular'
							alt='Profile Avatar'
							src={`/api/avatar/${profile?.username}`}
							sx={{
								height: 34,
								width: 34
							}}>
							{getInitials(profile)}
						</MuiAvatar>
					</ListItemIcon>
					<ListItemText
						primaryTypographyProps={{
							fontSize: 13,
							noWrap: true,
							maxWidth: 160
						}}
						secondaryTypographyProps={{
							fontSize: 11,
							noWrap: true,
							color: 'white',
							maxWidth: 160
						}}
						primary={profile?.name}
						secondary={profile?.username ?? ''}
					/>
				</ListItemButton>
			</List>
			{open && (
				<Box
					display={'flex'}
					justifyContent={'end'}>
					<Button
						onClick={onLogout}
						fullWidth
						sx={{
							borderRadius: 0,
							'&:hover': {
								color: theme => theme.palette.common.white,
								backgroundColor: theme =>
									theme.palette.info.main
							}
						}}>
						<>
							<ListItemIcon sx={{ minWidth: 30 }}>
								<LogoutIcon sx={{ color: 'white' }} />
							</ListItemIcon>
							<Typography
								variant='button'
								sx={{ color: 'white' }}>
								Logout
							</Typography>
						</>
					</Button>
				</Box>
			)}
		</Box>
	);
};
